import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Text } from 'rebass'
import { theme } from 'theme'

import SubmissionsSummary from './SubmissionsSummary'
import Review from './Review'
import Progress from './Progress'
import ViewPerformance from './ViewPerformance'
import Payouts from './Payouts'
import { PageNotFound } from 'components/Shared/ErrorPage'

interface PageHeaderProps {
    title: string
    subTitle: string
}
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subTitle }) => (
    <>
        <Text fontFamily="Clarika Geometric" fontWeight={700} fontSize="1.3em" mb={theme.spacing.xxxs}>
            {title}
        </Text>
        <Text
            fontFamily="Clarika Geometric"
            fontWeight={400}
            fontSize="1em"
            color={theme.colors.doveGrey}
            mb={theme.spacing.xs}
        >
            {subTitle}
        </Text>
    </>
)

const Campaign: React.FC<any> = () => {
    return (
        <Switch>
            <Route path="/submissions/review" component={Review} />
            <Route path="/submissions/progress" component={Progress} />
            <Route path="/submissions/view-performance" component={ViewPerformance} />
            <Route path="/submissions/payouts" component={Payouts} />
            <Route exact path="/submissions" component={SubmissionsSummary} />
            <Route path="*" component={PageNotFound} />
        </Switch>
    )
}

export default Campaign
